import { createContext, useContext } from "react"

export const PriceContext = createContext(null)

export const usePriceContext = () => useContext(PriceContext)
